import { POS_CONFIG } from './type';
import {
  CREATE_POS_CONFIG,
  CREATE_POS_CONFIG_FAILURE,
  CREATE_POS_CONFIG_SUCCESS,
  FETCH_POS_CONFIG,
  FETCH_POS_CONFIG_FAILURE,
  FETCH_POS_CONFIG_SUCCESS,
  UPDATE_POS_CONFIG,
  UPDATE_POS_CONFIG_FAILURE,
  UPDATE_POS_CONFIG_SUCCESS,
  DELETE_POS_CONFIG,
  DELETE_POS_CONFIG_FAILURE,
  DELETE_POS_CONFIG_SUCCESS,
  FETCH_ENABLED_PROVIDERS,
  FETCH_ENABLED_PROVIDERS_SUCCESS,
  FETCH_ENABLED_PROVIDERS_FAILURE,
  FETCH_POS_CONFIG_LIST,
  FETCH_POS_CONFIG_LIST_SUCCESS,
  FETCH_POS_CONFIG_LIST_FAILURE,
  FETCH_GUEST_LIST,
  FETCH_GUEST_LIST_SUCCESS,
  FETCH_GUEST_LIST_FAILURE,
} from './actions';

export const INITIAL_STATE: POS_CONFIG.PosConfigReducer = {
  isLoading: 0,
  error: {} as POS_CONFIG.Error,
  posConfig: {} as POS_CONFIG.IPosConfig,
  posConfigList: {} as POS_CONFIG.IPosConfigListResponse,
  enabledProviders: {} as POS_CONFIG.IEnabledProvidersResponse,
  createPosConfig: {} as POS_CONFIG.posConfigResponse,
  updatePosConfig: {} as POS_CONFIG.posConfigResponse,
  deletePosConfig: {} as POS_CONFIG.posConfigResponse,
  guestList: {} as POS_CONFIG.IGuestList,
};

const posConfigReducer = (
  action: IAction,
  state = INITIAL_STATE
): POS_CONFIG.PosConfigReducer => {
  switch (action.type) {
    case FETCH_ENABLED_PROVIDERS:
      return {
        ...state,
        isLoading: state.isLoading + 1,
        error: {} as POS_CONFIG.Error,
        enabledProviders: {} as POS_CONFIG.IEnabledProvidersResponse,
      };
    case FETCH_ENABLED_PROVIDERS_SUCCESS:
      return {
        ...state,
        isLoading: state.isLoading - 1,
        error: {} as POS_CONFIG.Error,
        enabledProviders: action.payload,
      };
    case FETCH_ENABLED_PROVIDERS_FAILURE:
      return {
        ...state,
        isLoading: state.isLoading - 1,
        error: {
          fetchEnabledProviders: action.payload.message,
        } as POS_CONFIG.Error,
      };
    case CREATE_POS_CONFIG:
      return {
        ...state,
        isLoading: state.isLoading + 1,
        error: {} as POS_CONFIG.Error,
        createPosConfig: {} as POS_CONFIG.posConfigResponse,
      };
    case CREATE_POS_CONFIG_SUCCESS:
      return {
        ...state,
        isLoading: state.isLoading - 1,
        error: {} as POS_CONFIG.Error,
        createPosConfig: action.payload,
      };
    case CREATE_POS_CONFIG_FAILURE:
      return {
        ...state,
        isLoading: state.isLoading - 1,
        error: { createPosConfig: action.payload.message } as POS_CONFIG.Error,
      };
    case FETCH_POS_CONFIG:
      return {
        ...state,
        isLoading: state.isLoading + 1,
        error: {} as POS_CONFIG.Error,
        posConfig: {} as POS_CONFIG.IPosConfig,
      };
    case FETCH_POS_CONFIG_SUCCESS:
      return {
        ...state,
        isLoading: state.isLoading - 1,
        error: {} as POS_CONFIG.Error,
        posConfig: action.payload,
      };
    case FETCH_POS_CONFIG_FAILURE:
      return {
        ...state,
        isLoading: state.isLoading - 1,
        error: { fetchPosConfig: action.payload.message } as POS_CONFIG.Error,
      };
    case FETCH_POS_CONFIG_LIST:
      return {
        ...state,
        isLoading: state.isLoading + 1,
        error: {} as POS_CONFIG.Error,
        posConfigList: {} as POS_CONFIG.IPosConfigListResponse,
      };
    case FETCH_POS_CONFIG_LIST_SUCCESS:
      return {
        ...state,
        isLoading: state.isLoading - 1,
        error: {} as POS_CONFIG.Error,
        posConfigList: action.payload,
      };
    case FETCH_POS_CONFIG_LIST_FAILURE:
      return {
        ...state,
        isLoading: state.isLoading - 1,
        error: {
          fetchPosConfigList: action.payload.message,
        } as POS_CONFIG.Error,
      };
    case UPDATE_POS_CONFIG:
      return {
        ...state,
        isLoading: state.isLoading + 1,
        error: {} as POS_CONFIG.Error,
        updatePosConfig: {} as POS_CONFIG.posConfigResponse,
      };
    case UPDATE_POS_CONFIG_SUCCESS:
      return {
        ...state,
        isLoading: state.isLoading - 1,
        error: {} as POS_CONFIG.Error,
        updatePosConfig: action.payload,
      };
    case UPDATE_POS_CONFIG_FAILURE:
      return {
        ...state,
        isLoading: state.isLoading - 1,
        error: { updatePosConfig: action.payload.message } as POS_CONFIG.Error,
      };
    case DELETE_POS_CONFIG:
      return {
        ...state,
        isLoading: state.isLoading + 1,
        error: {} as POS_CONFIG.Error,
        deletePosConfig: {} as POS_CONFIG.posConfigResponse,
      };
    case DELETE_POS_CONFIG_SUCCESS:
      return {
        ...state,
        isLoading: state.isLoading - 1,
        error: {} as POS_CONFIG.Error,
        deletePosConfig: action.payload,
      };
    case DELETE_POS_CONFIG_FAILURE:
      return {
        ...state,
        isLoading: state.isLoading - 1,
        error: { deletePosConfig: action.payload.message } as POS_CONFIG.Error,
      };

    case FETCH_GUEST_LIST:
      return {
        ...state,
        isLoading: state.isLoading + 1,
        error: {} as POS_CONFIG.Error,
        guestList: {} as POS_CONFIG.IGuestList,
      };
    case FETCH_GUEST_LIST_SUCCESS:
      return {
        ...state,
        isLoading: state.isLoading - 1,
        error: {} as POS_CONFIG.Error,
        guestList: action.payload,
      };
    case FETCH_GUEST_LIST_FAILURE:
      return {
        ...state,
        isLoading: state.isLoading - 1,
        error: { fetchGuestList: action.payload.message } as POS_CONFIG.Error,
      };
    default:
      return state;
  }
};

export default posConfigReducer;
